import { getCustomDisplayNameByDataset } from '_legacy/models/Type';
import {
    DATASET_DRY_CARGO,
    DATASET_LNG,
    DATASET_LPG_MIDSIZE,
    DATASET_LPG_VLGC,
    DATASET_PCG,
} from '../../../models/Datasets';
import { VOY } from '_legacy/components/toolPanels/commonSettings/OrderOrFixtureTypes';

const NonEmptyVoyDatasets = [
    DATASET_DRY_CARGO,
    DATASET_PCG,
    DATASET_LPG_VLGC,
    DATASET_LPG_MIDSIZE,
    DATASET_LNG,
];

const TypeFormatter = (params) => {
    const { value, node, datasetId } = params;

    const currentDatasetId =
        node && node.data ? node.data.datasetId : datasetId;
    if (
        value === VOY &&
        node != null &&
        !node.group &&
        !NonEmptyVoyDatasets.includes(currentDatasetId)
    ) {
        return '';
    }

    return getTypeValueByDataset(value, currentDatasetId);
};

export const AllTypeFormatter = (value, datasetId) => {
    if (!value) {
        return '';
    }

    return getTypeValueByDataset(value, datasetId);
};

export const getTypeValueByDataset = (value, datasetId) => {
    if (datasetId === DATASET_LNG) {
        const customNames = getCustomDisplayNameByDataset(datasetId);
        return customNames.find((x) => x.value === value)?.label ?? value;
    }

    return value;
};

export default TypeFormatter;
